import { ServiceList } from "features/service/model/serviceList";
import { ApiEnvelope, PagedResponse, Page } from "shared/model/api";
import { agroApi } from "shared/api/agroApi";

type ServicePageReq = { page: number; size: number };

type GetAllResp = ApiEnvelope<Page<ServiceList>>;

type SingleResp = ApiEnvelope<ServiceList>;

export const serviceList = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST /service/get-all (pagination)
    getServiceList: builder.query<GetAllResp, ServicePageReq>({
      query: ({ page, size }) => ({
        url: `/service/get-all`,
        method: "POST",
        body: JSON.stringify({ page, size }),
      }),
      providesTags: (res) =>
        res?.res.content
          ? [
              ...res.res.content.map((item) => ({
                type: "Services" as const,
                id: item.code,
              })),
              { type: "Services", id: "LIST" },
            ]
          : [{ type: "Services", id: "LIST" }],
    }),

    // GET /service/{code}
    getServiceByCode: builder.query<SingleResp, { code: string }>({
      query: ({ code }) => ({
        url: `/service/${encodeURIComponent(code)}`,
        method: "GET",
      }),
      providesTags: (_res, _err, arg) => [
        { type: "Services", id: arg.code },
        { type: "Services", id: "LIST" },
      ],
    }),

    // POST /service (create)
    addService: builder.mutation<
      PagedResponse<ServiceList>,
      {
        body: Pick<ServiceList, "nameRu" | "nameKy"> & Partial<ServiceList>;
      }
    >({
      query: ({ body }) => ({
        url: `/service`,
        method: "POST",
        body: JSON.stringify(body),
      }),
      invalidatesTags: [{ type: "Services", id: "LIST" }],
    }),

    // PUT /service (update)
    editService: builder.mutation<
      PagedResponse<ServiceList>,
      { body: Partial<ServiceList> & { code: string } }
    >({
      query: ({ body }) => ({
        url: `/service`,
        method: "PUT",
        body: JSON.stringify(body),
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Services", id: arg.body.code },
        { type: "Services", id: "LIST" },
      ],
    }),

    // DELETE /service/{code}
    removeService: builder.mutation<
      PagedResponse<ServiceList>,
      { code: string }
    >({
      query: ({ code }) => ({
        url: `/service/${encodeURIComponent(code)}`,
        method: "DELETE",
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Services", id: arg.code },
        { type: "Services", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetServiceListQuery,
  useGetServiceByCodeQuery,
  useAddServiceMutation,
  useEditServiceMutation,
  useRemoveServiceMutation,
} = serviceList;
